'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var setDeviceType = require('./utils/set-device-type');
var tagmanager = require('../tagmanager');

module.exports = {
  /**
   * Inserts the Google Optimize init script and watches for DOM mutations.
   *
   * @param {string} containerId - Google tag manager container id.
   */
  initialise: function initialise(containerId) {
    // this is required to run before the first activate event
    setDeviceType();

    var Observer = window.MutationObserver || window.WebKitMutationObserver;
    if (Observer) {
      /* eslint-disable */
      (function (a, s, y, n, c, h, i, d, e) {
        s.className += ' ' + y;
        h.start = 1 * new Date();
        h.end = i = function i() {
          s.className = s.className.replace(RegExp(' ?' + y), '');
        };
        (a[n] = a[n] || []).hide = h;
        setTimeout(function () {
          i();h.end = null;
        }, c);
        h.timeout = c;
      })(window, document.documentElement, 'async-hide', 'dataLayer', 4000, _defineProperty({}, containerId, true));
      /* eslint-enable */

      window.addEventListener('DOMContentLoaded', function () {
        tagmanager.event('optimize.activate');
      });

      new Observer(function () {
        tagmanager.event('optimize.activate');
      }).observe(document.body, { attributes: true, characterData: true, subtree: true });
    }
  }
};